import request from './request';
import { ClientAccount, SessionData } from '../models';

const accountService = {
  profile: (data: SessionData) => request.post<{ craftmen: ClientAccount }>('/verify-client', data),
};

export default accountService;
